export var noopLogger = new Proxy({}, {
    get: function () { return function () { return null; }; }
});
//# sourceMappingURL=noopLogger.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/keycloak/es/noopLogger.js
// module id = 730
// module chunks = 118